import { BookResult } from '@/types/search';

export function normalizeOpenLibraryId(id: string): string {
  if (!id) return '';
  // Remove '/works/' prefix if present, return just the ID
  return id.replace(/^\/works\//, '');
}

export function isUuid(id: string): boolean {
  if (!id) return false;
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
}

export function mapOpenLibraryDoc(doc: any): BookResult {
  const coverUrl = doc.cover_i ? `https://covers.openlibrary.org/b/id/${doc.cover_i}-M.jpg` : undefined;
  const isbnArr: string[] = doc.isbn || [];
  
  return {
    open_library_id: normalizeOpenLibraryId(doc.key || ''),
    title: doc.title || 'Untitled',
    subtitle: doc.subtitle,
    authors: doc.author_name || [],
    published_year: doc.first_publish_year,
    cover_url: coverUrl,
    isbn10: isbnArr.find((x) => x?.length === 10),
    isbn13: isbnArr.find((x) => x?.length === 13),
    synopsis: undefined,
    isLocal: false,
  };
}

export async function searchOpenLibrary(
  query: string, 
  type: 'title' | 'author' = 'title', 
  page = 1,
  limit = 5,
  language = 'eng'
): Promise<{ results: BookResult[]; hasMore: boolean }> {
  const params = new URLSearchParams();
  if (type === 'author') {
    params.set('author', query);
  } else {
    params.set('title', query);
  }
  params.set('page', String(page));
  params.set('limit', String(limit));
  params.set('language', language);
  params.set('sort', 'rating'); // Prioritize popular books

  const response = await fetch(`https://openlibrary.org/search.json?${params.toString()}`);
  if (!response.ok) {
    throw new Error(`OpenLibrary error ${response.status}`);
  }
  
  const data = await response.json();
  const results = (data.docs || []).slice(0, limit).map(mapOpenLibraryDoc);
  
  const start = data.start || (page - 1) * 100;
  const hasMore = start + (data.docs?.length || 0) < (data.numFound || 0);
  
  return { results, hasMore };
}